module.exports = __webpack_public_path__ + "static/media/title.80e3527a.svg";